import React, { useEffect } from 'react';
import {  useSelector } from 'react-redux';

import { DataTable } from 'CommonComponent';
import { Header, Columns } from './component';

const TotalTabs = () => {

    const { data, loading } = useSelector(state => state.acdReportState.dailyTotal);

    return (
        <div>
            <DataTable
                columns={Columns}
                data={data}
                serverSide={false}
                showSearch={false}
                loading={loading}
                className='table-container'
            />
        </div>
    )
};

export default TotalTabs;
